import { emperor } from '~/services';
import { Layout } from '~/types/layout';

export const getLayout = async (layoutName: string) => {
  return await emperor.get<{layout: Layout}>(`/user/layouts/${layoutName}`);
};
